import React from "react"; 
import { X } from "lucide-react"; 
import Select from "react-select"; 
import { Role } from "../../../models/roles";  
import '../../../styles/roleModel.css';

interface RoleModalProps {   
  isOpen: boolean;   
  onClose: () => void;   
  onSave: (e: React.FormEvent) => void;   
  currentRole: Role;   
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;   
  handleSelectChange: (selectedOption: any, action: any) => void;
  handlePermissionChange: (menuName: string, permission: string, checked: boolean) => void;
  validationErrors: {     
    userType?: string;     
    status?: string;   
  };   
  editMode: boolean;   
  isLoading: boolean; 
}  

const RoleModal: React.FC<RoleModalProps> = ({   
  isOpen,   
  onClose,   
  onSave,   
  currentRole,   
  handleInputChange,
  handleSelectChange,
  handlePermissionChange,
  validationErrors,   
  editMode,   
  isLoading, 
}) => {   

  if (!isOpen) return null;    
  
  const statusOptions = [     
    { value: "ACTIVE", label: "ACTIVE" },     
    { value: "INACTIVE", label: "INACTIVE" },   
  ];
 
const menusList = currentRole.menus ? Object.keys(currentRole.menus).sort() : [];

  return (     
    <div className="item-models-modal-overlay">       
      <div className="item-models-modal role-modal">         
        <div className="item-models-modal-header">           
          <h5>{editMode ? "Edit Role" : "Add Role"}</h5>           
          <button className="item-models-modal-close" onClick={onClose}>             
            <X size={18} />           
          </button>         
        </div>         
        <div className="modal-form-container">           
          <form onSubmit={onSave} noValidate>
            <div className="form-group">
              <label htmlFor="userType">User Type</label>
              <input
                type="text"
                id="userType"
                name="userType"
                value={currentRole.userType}
                onChange={handleInputChange}
                className={validationErrors.userType ? "input-error" : ""}
                placeholder="Enter User Type"
                required
              />
              {validationErrors.userType && (
                <div className="form-error-message">
                  {validationErrors.userType}
                </div>
              )}
            </div>

            {editMode && (               
              <div className="select-container">                 
                <Select                   
                  name="status"                   
                  options={statusOptions}                   
                  value={statusOptions.find(                     
                    (option) => option.value === currentRole.status                   
                  )}                   
                  onChange={(selected, action) =>                      
                    handleSelectChange(selected, action)                   
                  }                   
                  placeholder="Select Status"                   
                  className={validationErrors.status ? "select-error" : ""}                   
                  classNamePrefix="react-select"                   
                  menuPortalTarget={document.body}                   
                  styles={{                     
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),                   
                  }}                 
                />                 
                {validationErrors.status && (                   
                  <div className="form-error-message">                     
                    {validationErrors.status}                   
                  </div>                 
                )}               
              </div>             
            )}
                        
            <div className="menu-permissions-container">
              <div className="permissions-table">
                <div className="permissions-header">
                  <div className="module-name">Menu</div>
                  <div className="permission-options">
                    <span className="permission-label">Create</span>
                    <span className="permission-label">View</span>
                    <span className="permission-label">Edit</span>
                    <span className="permission-label">Delete</span>
                  </div>
                </div>
                
                <div className="permissions-list">
                  {menusList.map((menuName) => (
                    <div key={menuName} className="permission-row">
                      <div className="module-name">
                        <span>{menuName}</span>
                      </div>
                      <div className="permission-options">
                        <div className="checkbox-wrapper">
                          <input
                            type="checkbox"
                            id={`${menuName}-create`}
                            checked={currentRole.menus[menuName]?.create || false}
                            onChange={(e) => handlePermissionChange(menuName, 'create', e.target.checked)}
                          />
                        </div>
                        
                        <div className="checkbox-wrapper">
                          <input
                            type="checkbox"
                            id={`${menuName}-read`}
                            checked={currentRole.menus[menuName]?.read || false}
                            onChange={(e) => handlePermissionChange(menuName, 'read', e.target.checked)}
                          />
                        </div>
                        
                        <div className="checkbox-wrapper">
                          <input
                            type="checkbox"
                            id={`${menuName}-update`}
                            checked={currentRole.menus[menuName]?.update || false}
                            onChange={(e) => handlePermissionChange(menuName, 'update', e.target.checked)}
                          />
                        </div>
                        
                        <div className="checkbox-wrapper">
                          <input
                            type="checkbox"
                            id={`${menuName}-delete`}
                            checked={currentRole.menus[menuName]?.delete || false}
                            onChange={(e) => handlePermissionChange(menuName, 'delete', e.target.checked)}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            
            <div className="modal-footer">
              <button               
                type="submit"               
                disabled={isLoading}               
                className="create-role-button"             
              >               
                {isLoading ? "Saving..." : editMode ? "Update Role" : "Create Role"}             
              </button>
            </div>           
          </form>         
        </div>       
      </div>     
    </div>   
  ); 
};  

export default RoleModal;